import { axios, handleError } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altAdminLists = (data) => ({
  type: TYPES.ALT_ADMIN_LISTS,
  data,
})

// Export for compatibility with existing code
export const altAdminData = altAdminLists
export const altAdminStatus = (data) => altAdminLists(data)

export const getAllAdmins = (page = 1, limit = 10) => async (dispatch) => {
  try {
    const response = await axios.get(`/admin/admins?page=${page}&limit=${limit}`)
    
    console.log(response, "admin2")
    if (response && response.admins) {
      const normalizedData = {
        data: response.admins.map(admin => ({
          id: admin.id,
          firstName: admin.firstName,
          lastName: admin.lastName,
          fullName: `${admin.firstName} ${admin.lastName}`,
          email: admin.email,
          phone: admin.phone,
          role: admin.role,
          status: admin.status, // ACTIVE or INACTIVE (string from admins table)
          permissions: admin.permissions || '[]',
          createdAt: admin.createdAt,
          updatedAt: admin.updatedAt,
        })),
        pagination: response.pagination
      }
      
      dispatch(altAdminLists(normalizedData))
      return normalizedData
    }
  } catch (error) {
    console.error('Error fetching admins:', error)
    handleError(error.response)
  }
}

export const getSpecificAdmin = (adminId) => async (dispatch) => {
  try {
    const response = await axios.get(`/admin/admins/${adminId}`)
    
    if (response && response.data) {
      return {
        data: {
          id: response.data.id,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          fullName: `${response.data.firstName} ${response.data.lastName}`,
          email: response.data.email,
          phone: response.data.phone,
          role: response.data.role,
          status: response.data.status, // ACTIVE or INACTIVE (string)
          permissions: response.data.permissions || '[]',
          createdAt: response.data.createdAt,
          updatedAt: response.data.updatedAt,
        }
      }
    }
  } catch (error) {
    console.error('Error fetching admin:', error)
    handleError(error.response)
  }
}

export const getAdminStats = () => async () => {
  try {
    const response = await axios.get('/admin/admins/stats')
    
    if (response && response.data) {
      return response.data
    }
  } catch (error) {
    console.error('Error fetching admin stats:', error)
    handleError(error.response)
  }
}

// Compatibility export
export const AdminDetails = getAdminStats

export const createAdmin = (data) => async (dispatch) => {
  try {
    const response = await axios.post('/admin/admins', data)
    
    if (response && response.data) {
      toast.success('Admin created successfully')
      await dispatch(getAllAdmins())
      return { status: 201 }
    }
  } catch (error) {
    console.error('Error creating admin:', error)
    handleError(error.response)
    throw error
  }
}

export const updateAdmin = (adminId, data) => async (dispatch) => {
  try {
    const response = await axios.put(`/admin/admins/${adminId}`, data)
    
    if (response && response.data) {
      toast.success('Admin updated successfully')
      await dispatch(getAllAdmins())
      return response.data
    }
  } catch (error) {
    console.error('Error updating admin:', error)
    handleError(error.response)
  }
}

export const deleteAdmin = (adminId) => async (dispatch) => {
  try {
    const response = await axios.delete(`/admin/admins/${adminId}`)
    
    if (response && response.data) {
      toast.success('Admin deleted successfully')
      await dispatch(getAllAdmins())
      return response.data
    }
  } catch (error) {
    console.error('Error deleting admin:', error)
    handleError(error.response)
  }
}

export const toggleAdminStatus = (adminId) => async (dispatch) => {
  try {
    const response = await axios.put(`/admin/admins/${adminId}/status`)
    
    if (response && response.data) {
      toast.success('Admin status updated successfully')
      await dispatch(getAllAdmins())
      return response.data
    }
  } catch (error) {
    console.error('Error toggling admin status:', error)
    handleError(error.response)
  }
}

// Order-related exports
const altAdminOrders = (data) => ({
  type: TYPES.ALT_ADMIN_ORDERS,
  data,
})

export const AdminOrders = (page = 1, limit = 10) => async (dispatch) => {
  try {
    const response = await axios.get(`/admin/orders?page=${page}&limit=${limit}`)
    
    if (response && response.data) {
      const ordersData = {
        order: response.data,
        data: response.data,
        page: response.pagination?.page || 1,
        totalPages: response.pagination?.totalPages || 1,
        totalCount: response.pagination?.totalCount || 0,
        pagination: response.pagination
      }
      
      dispatch(altAdminOrders(ordersData))
      return ordersData
    }
  } catch (error) {
    console.error('Error fetching orders:', error)
    handleError(error.response)
    const emptyData = { order: [], data: [], page: 0, pagination: {} }
    dispatch(altAdminOrders(emptyData))
    return emptyData
  }
}

export const getAllOrdersPage = AdminOrders

